import { Navigate, useParams } from 'react-router-dom';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';

export const LegacyRmmmRedirect = () => {
  const { company, '*': suffix } = useParams<{ company: string; '*': string }>();
  const { dtc_mmm_run: hasDtcRun, commerce_mmm_run: hasCommerceRun } = useCompanyInfo();
  const target = hasCommerceRun && !hasDtcRun ? 'commerce-mmm' : 'dtc-mmm';
  return <Navigate to={`/${company}/${target}${suffix ? `/${suffix}` : ''}`} replace />;
};
